export default (
  state = { isLoading: false, services: [], products: [], subcategories: [], categories: [] },
  action
) => {
  switch (action.type) {
    case 'FETCH_SEARCH':
      return { ...state, isLoading: true }
    case 'FETCH_SEARCH_SUCCESS':
      const subcategories = action.payload.data.subcategories

      return {
        ...state,
        isLoading: false,
        services: action.payload.data.services,
        products: action.payload.data.products,
        subcategories: action.payload.data.subcategories.slice(
          0,
          subcategories.length > 5 ? 5 : subcategories.length
        ),
        categories: action.payload.data.categories
      }
    case 'FETCH_SEARCH_FAIL':
      return { ...state, isLoading: false, error: action.error }
    case 'EMPTY_SEARCH':
      return {
        ...state,
        isLoading: false,
        services: [],
        products: [],
        subcategories: [],
        categories: []
      }
    default:
      return { ...state }
  }
}



// WEBPACK FOOTER //
// ./src/App/Header/Search/reducer.js